import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { SETTING_SERVICES_ENDPOINTS } from 'src/app/core/api/endpoints/setting-services.endpoints';

@Injectable({
  providedIn: 'root'
})
export class SettingServicesService {
  private api = inject(ApiService);

  getUnitOfMeasurements(params): Observable<any> {
    return this.api.get(SETTING_SERVICES_ENDPOINTS.V1.UNIT_OF_MEASUREMENTS,{params: params});
  }

  getRooms(params): Observable<any> {
    return this.api.get(SETTING_SERVICES_ENDPOINTS.V1.ROOMS,{params: params});
  }

  getFloors(params): Observable<any> {
    return this.api.get(SETTING_SERVICES_ENDPOINTS.V1.FLOORS,{params:params});
  }

  getRecommendations(params): Observable<any> {
    return this.api.get(SETTING_SERVICES_ENDPOINTS.V1.NOTE_RECOMMENDATIONS,{params:params});
  }

  getTechnicalProblems(): Observable<any> {
    return this.api.get(SETTING_SERVICES_ENDPOINTS.V1.TECHNICAL_PROBLEMS_TYPES);
  }
  
  addRoom(room): Observable<any> {
    return this.api.post(SETTING_SERVICES_ENDPOINTS.V1.ROOMS, room);
  }

  updateRoom(id, room): Observable<any> {
    return this.api.put(SETTING_SERVICES_ENDPOINTS.V1.ROOM_DETAIL(id), room);
  }

  addFloor(floor): Observable<any> {
    return this.api.post(SETTING_SERVICES_ENDPOINTS.V1.FLOORS, floor);
  }

  updateFloor(id, floor) {
    return this.api.put(SETTING_SERVICES_ENDPOINTS.V1.FLOOR_DETAIL(id), floor);
  }

  addUnitOfMeasurements(unit): Observable<any> {
    return this.api.post(SETTING_SERVICES_ENDPOINTS.V1.UNIT_OF_MEASUREMENTS, unit);
  }

  updateUnitOfMeasurements(id, unit): Observable<any> {
    return this.api.put(SETTING_SERVICES_ENDPOINTS.V1.UNIT_OF_MEASUREMENT_DETAIL(id), unit);
  }
  addStatus(status): Observable<any> {
    return this.api.post(SETTING_SERVICES_ENDPOINTS.V1.COMPLETION_STATUSES, status);
  }
  
  addRecommendation(data): Observable<any> {
    return this.api.post(SETTING_SERVICES_ENDPOINTS.V1.NOTE_RECOMMENDATIONS, data)
  }
  updateRecommendation(id, data): Observable<any> {
    return this.api.put(SETTING_SERVICES_ENDPOINTS.V1.NOTE_RECOMMENDATION_DETAIL(id), data);
  }

}
